import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCreateCustomModuleMutation, useMeQuery } from '@platform/state/api';
import { useAppDispatch } from '@platform/state/hooks';
import { toastShown } from '@platform/state/slices/uiSlice';
import { appRoutes } from '../../shell/appRoutes';
import { errorText } from '../system/errorText';
import type { INewCustomModule } from './INewCustomModule';

/**
 * «+ Новий модуль» (прототип v4 newModule: moduleTpl('mod_…', 'New module', 'Item', 'ITM', ['Open','In progress','Done'], …, 'General') і
 * builderMod = новий модуль; ADR-025): POST …/custom-modules без тіла — сервер бере шаблон прототипу з підписами обома мовами; конструктор
 * відкриває визначення нового модуля (тип запису має ключ модуля), доки каталог і визначення перечитуються — показує очікування.
 */
export function useNewCustomModule(ws: string): INewCustomModule {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { data: me } = useMeQuery();
  const [createModule, state] = useCreateCustomModuleMutation();
  const [pending, setPending] = useState<string | null>(null);
  const create = () => {
    createModule({ ws, body: {} }).unwrap()
      .then((m) => { setPending(m.key); navigate(appRoutes.customize('builder', m.key)); })
      .catch((e: unknown) => dispatch(toastShown({ kind: 'error', text: errorText(e, t('sysPages.saveFailed')) })));
  };
  return { create, canCreate: !!me?.workspaces.find((w) => w.id === ws)?.myCapabilities.includes('customize'), busy: state.isLoading, pending };
}
